// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-icon {
  margin-top: 30px;
  font-size: 10rem;
}

.error-message {
  white-space: pre-wrap;
}

h5.secondary-font {
  font-family: "Montserrat" !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/geo-location-view/geo-location-view.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,qBAAA;AACJ;;AAEA;EACI,oCAAA;AACJ","sourcesContent":["ion-icon {\n    margin-top: 30px;\n    font-size: 10rem;\n}\n\n.error-message{\n    white-space: pre-wrap;\n}\n\nh5.secondary-font {\n    font-family: 'Montserrat' !important;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
